__turbopack_context__.v({
  "accessibility_icons_icons": "AccessibilityIcons-module-scss-module__T_7hda__accessibility_icons_icons",
  "icon": "AccessibilityIcons-module-scss-module__T_7hda__icon",
});
